(ns hypnos.backoffice.subs
  "Subscriptions for the backOffice application."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Auth

(rf/reg-sub
 :backoffice/auth
 (fn [db [_]]
   (get-in db [:auth])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; UI

(rf/reg-sub
 :backoffice/active-panel
 (fn [db _]
   (get-in db [:ui :active-panel])))

(rf/reg-sub
 :backoffice/aside
 (fn [db _]
   (get-in db [:ui :aside])))

(rf/reg-sub
 :backoffice/gql-request-in-progress?
 (fn [db _]
   (get-in db [:ui :loading?])))

(rf/reg-sub
 :backoffice/communication
 (fn [db _]
   (get-in db [:communication])))

(rf/reg-sub
 :backoffice/error
 (fn [db _]
   (get-in db [:error])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Catalog

(rf/reg-sub
 :backoffice/catalog
 (fn [db _]
   (get-in db [:catalog])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Consult(s)

(rf/reg-sub
 :backoffice/consults
 (fn [db _]
   (get-in db [:consults])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Patient(s)

(rf/reg-sub
 :backoffice/patients-query
 (fn [db _]
   (get-in db [:patients :query])))

(rf/reg-sub
 :backoffice/patient
 (fn [db _]
   (get-in db [:patient])))

(rf/reg-sub
 :backoffice/patients
 (fn [db _]
   (get-in db [:patients])))

(rf/reg-sub
 :backoffice/recommendations-with-note
 (fn [db _]
   (get-in db [:recommendations-with-note])))

(rf/reg-sub
 :backoffice/referral
 (fn [db _]
   (get-in db [:referral])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Organization

(rf/reg-sub
 :backoffice/organization
 (fn [db _]
   (get-in db [:organization])))

(rf/reg-sub
 :backoffice/user
 (fn [db [_]]
   (get-in db [:auth :user])))
